import {
  Button,
  CardMedia,
  Checkbox,
  Input,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import AuthLayout from "./AuthLayout";
import React, { ChangeEvent, useEffect, useState } from "react";
import "react-phone-input-2/lib/bootstrap.css";
import CloseIcon from "@mui/icons-material/Close";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ChangeRequest from "../../Modals/changeRequest";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  useLazyGetProfileQuery,
  useUpdateProfileMutation,
} from "../../service/auth";
import { showError, showToast } from "../../constants/toasts";
import {
  useLazyGetCategoryQuery,
  useLazyGetSubCategoryQuery,
} from "../../service/main";
import { Category, VendorStore } from "../../types/General";
import PhoneInput from "react-phone-input-2";
import { UploadMedia } from "../../utils/mediaUpload";
import { VENDOR_PROFILE_STEPS } from "../../utils/enums";
import { getFromStorage, STORAGE_KEYS } from "../../helpers";
import { User } from "../../types/User";
import Loader from "../../constants/Loader";

const bioTemplates = [
  "Handcrafted products made with passion in the UAE",
  "Locally made goods inspired by modern heritage and tradition",
  "Unique curated items from a licensed UAE home business",
  // Admin can add/edit templates here
];
const SignupForm = () => {
  const navigate = useNavigate();
  const [updateProfile] = useUpdateProfileMutation();
  const [getCategory] = useLazyGetCategoryQuery();
  const [getSubCategory] = useLazyGetSubCategoryQuery();
  const [getProfile] = useLazyGetProfileQuery();

  const userData = getFromStorage(STORAGE_KEYS.userData);
  const parsedUserData: User | null = userData
    ? (JSON.parse(userData) as User)
    : null;
  console.log("parsedUserData");

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  // const categories = ["Fashion", "Beauty", "Electronics", "Books"];
  // const subCategories = ["Men", "Women", "Kids", "Accessories"];

  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState<string[]>(
    []
  );
  const [selectedAddress, setSelectedAddress] = useState<string>("");

  const [openCategory, setOpenCategory] = useState(false);
  const [openSubCategory, setOpenSubCategory] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);
  const [subCategories, setSubCategories] = useState<Category[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [vendorData, setVendorData] = useState<VendorStore | null>(null);

  const handleItemClick = (
    event: React.MouseEvent,
    value: string,
    selectedItems: string[],
    setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    event.stopPropagation();
    const selectedIndex = selectedItems.indexOf(value);
    let newSelected: string[] = [];

    if (selectedIndex === -1) newSelected = [...selectedItems, value];
    else newSelected = selectedItems.filter((v) => v !== value);

    setSelectedItems(newSelected);
  };

  // ✅ Select All / Clear All handler
  const handleSelectAll = (
    event: React.MouseEvent,
    allItems: string[],
    selectedItems: string[],
    setSelectedItems: React.Dispatch<React.SetStateAction<string[]>>
  ) => {
    event.stopPropagation();
    if (selectedItems.length === allItems.length) setSelectedItems([]);
    else setSelectedItems(allItems);
  };

  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone", phone?.replace(country.dialCode, ""));
    formik.setFieldValue("countryCode", country?.dialCode);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      shortName: vendorData?.shortName || "",
      storeName: vendorData?.storeName || "",
      email: parsedUserData?.email || "",
      phone: vendorData?.phone || "",
      countryCode: vendorData?.countryCode || "",
      licencse: vendorData?.licenceNumber || "",
      bio: vendorData?.description || "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
          "Enter a valid email address"
        ),
      shortName: Yup.string().required().required("Short Name is required"),
      storeName: Yup.string().required().required("Store Name is required"),
      licencse: Yup.string().required().required("License is required"),
      bio: Yup.string().required().required("Bio is required"),
    }),

    onSubmit: async (values) => {
      formik.setSubmitting(true);

      if (!image) {
        showError("Please upload image");
        return;
      }

      if (
        !selectedAddress ||
        !selectedCategories?.length ||
        !selectedSubCategories?.length
      ) {
        return;
      }

      const body = {
        logo: image || "",
        shortName: values.shortName,
        storeName: values.storeName,
        email: values.email,
        countryCode: values.countryCode,
        phone: values.phone,
        licenceNumber: values.licencse,
        storeAddress: selectedAddress,
        category: selectedCategories,
        subCategory: selectedSubCategories,
        description: values.bio,
        step: VENDOR_PROFILE_STEPS.PERSONAL,
      };

      try {
        setLoading(true);
        const response = await updateProfile(body).unwrap();
        setLoading(false);
        if (response?.statusCode === 200) {
          navigate("/subscription-form");
          showToast(response?.message || "");
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    },
  });

  const handleProfileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    if (!file) {
      setImage("");
      return;
    }

    const imageUrl = (await UploadMedia(file)) as any;
    if (imageUrl?.data) {
      setImage(imageUrl?.data || "");
    }
  };

  const getCategoryApi = async () => {
    setLoading(true);
    try {
      const response = await getCategory({}).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setCategories(response?.data?.data || []);
      } else {
        setCategories([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getSubCategoryApi = async () => {
    setLoading(true);
    try {
      const parentIds = selectedCategories?.map((item) => item).join(",");

      const response = await getSubCategory({
        parentId: parentIds,
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setSubCategories(response?.data?.data || []);
      } else {
        setSubCategories([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getProfileAPi = async () => {
    setLoading(true);
    try {
      const response = await getProfile({ id: parsedUserData?.id }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setImage(response?.data?.logo || "");
        setSelectedAddress(response?.data?.storeAddress || "");
        setSelectedCategories(
          response?.data?.category?.map((item: any) => item._id) || []
        );
        setSelectedSubCategories(
          response?.data?.subCategory?.map((item: any) => item._id) || []
        );
        setVendorData(response?.data);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getCategoryApi();
    getProfileAPi();
  }, []);

  useEffect(() => {
    if (selectedCategories?.length) {
      getSubCategoryApi();
    }
  }, [selectedCategories]);

  return (
    <>
      <Loader isLoad={loading} />
      <AuthLayout>
        <div className="authBox signup_box">
          <h2>Setup Store</h2>

          <form className="form" onSubmit={formik.handleSubmit}>
            {/* IMAGE UPLOAD */}
            <div className="gap_p">
              <div className="control_group w_100">
                <label htmlFor="icon-button-file">Upload Logo</label>
                {image ? (
                  <div className="upload_image">
                    <div className="upload_image_holder">
                      <figure>
                        <CardMedia component="img" image={image} alt="photo" />
                      </figure>
                      <CloseIcon
                        onClick={() => {
                          setImage("");
                          setFileName("");
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <label className="upload_image" htmlFor="icon-button-file">
                    <Input
                      sx={{ display: "none" }}
                      id="icon-button-file"
                      type="file"
                      inputProps={{
                        accept: "image/png,image/jpeg",
                      }}
                      onChange={(e: any) => {
                        handleProfileUpload(e);
                        e.target.value = null;
                      }}
                    />
                    <span className="upload_image_holder">
                      <figure className="add_img">
                        <img
                          src="/static/images/user_placeholder.png"
                          alt="icon"
                        />
                        <span className="upload_img_icon">
                          <img src="/static/images/edit2_icon.svg" alt="icon" />
                        </span>
                      </figure>
                    </span>
                  </label>
                )}
              </div>

              {/* OWNER NAME */}
              <div className="control_group w_33">
                <label htmlFor="ownerName">Short Name </label>
                <TextField
                  id="shortName"
                  name="shortName"
                  placeholder="Enter Short Name"
                  className="text_field"
                  fullWidth
                  value={formik.values.shortName}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.shortName &&
                    typeof formik.errors.shortName === "string"
                      ? formik.errors.shortName
                      : ""
                  }
                />
              </div>
              <div className="control_group w_33">
                <label htmlFor="ownerName">Store Name</label>
                <TextField
                  id="storeName"
                  name="storeName"
                  placeholder="Enter Store Name"
                  className="text_field"
                  fullWidth
                  value={formik.values.storeName}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.storeName &&
                    typeof formik.errors.storeName === "string"
                      ? formik.errors.storeName
                      : ""
                  }
                />
              </div>

              {/* PHONE NUMBER */}

              {/* EMAIL */}
              <div className="control_group w_33">
                <label htmlFor="email">Contact Email </label>
                <TextField
                  id="email"
                  name="email"
                  type="email"
                  className="text_field"
                  placeholder="Enter Email Address"
                  disabled
                  fullWidth
                  value={formik.values.email}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.email &&
                    typeof formik.errors.email === "string"
                      ? formik.errors.email
                      : ""
                  }
                />
              </div>

              <div className="control_group w_33">
                <label>Phone Number*</label>
                <PhoneInput
                  enableSearch
                  value={formik.values.countryCode + formik.values.phone}
                  country={"uae"}
                  inputClass="phoneInput"
                  onChange={(phone, country) =>
                    handleChangePhone(phone, country)
                  }
                  inputStyle={{ width: "100%" }}
                  buttonClass="phoneBtn"
                  placeholder="Phone Number"
                />
                <p className="err_msg">
                  {error && !formik.values.phone?.length
                    ? "Phone number is required"
                    : ""}
                </p>
              </div>

              <div className="control_group w_33">
                <label htmlFor="storeName">License number</label>
                <TextField
                  id="licencse"
                  name="licencse"
                  placeholder="Enter License number"
                  fullWidth
                  value={formik.values.licencse}
                  className="text_field"
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.licencse &&
                    typeof formik.errors.licencse === "string"
                      ? formik.errors.licencse
                      : ""
                  }
                />
              </div>

              <div className="control_group w_33">
                <label htmlFor="storeName">Store Address (Emirate)</label>
                <Select
                  displayEmpty
                  fullWidth
                  value={selectedAddress}
                  onChange={(e) => setSelectedAddress(e.target.value)}
                >
                  <MenuItem disabled value="">
                    Select Address
                  </MenuItem>
                  <MenuItem value="Abu Dhabi">Abu Dhabi</MenuItem>
                  <MenuItem value="Dubai">Dubai</MenuItem>
                  <MenuItem value="Sharjah">Sharjah</MenuItem>
                  <MenuItem value="Ajman">Ajman</MenuItem>
                  <MenuItem value="Umm al-Quwain">Umm al-Quwain</MenuItem>
                  <MenuItem value="Ras al-Khaimah">Ras al-Khaimah</MenuItem>
                  <MenuItem value="Fujairah">Fujairah</MenuItem>
                </Select>
                {error && !selectedAddress ? (
                  <h6 className="err_msg">Address is required</h6>
                ) : (
                  ""
                )}
              </div>

              <div className="control_group w_33">
                <label htmlFor="category">
                  Category{" "}
                  <Tooltip
                    title="To change the category you need to send a request to admin"
                    enterTouchDelay={0}
                    leaveTouchDelay={1000}
                  >
                    <span className="info_icon">
                      <InfoOutlinedIcon fontSize="small" />
                    </span>
                  </Tooltip>
                </label>

                <Select
                  multiple
                  displayEmpty
                  open={openCategory}
                  onOpen={() => setOpenCategory(true)}
                  onClose={() => setOpenCategory(false)}
                  value={selectedCategories}
                  renderValue={(selected) => {
                    if ((selected as string[]).length === 0) {
                      return (
                        <span style={{ color: "#999" }}>Select Category</span>
                      );
                    }
                    return (selected as string[])
                      .map(
                        (id) => categories.find((cat) => cat.id === id)?.name
                      )
                      .filter(Boolean)
                      .join(", ");
                  }}
                  fullWidth
                  MenuProps={{
                    PaperProps: { style: { maxHeight: 300 } },
                  }}
                >
                  {/* Select All / Clear All */}
                  <MenuItem
                    value="all"
                    onClick={(e) =>
                      handleSelectAll(
                        e,
                        categories?.map((cat) => cat?.id),
                        selectedCategories,
                        setSelectedCategories
                      )
                    }
                  >
                    <Checkbox
                      checked={
                        categories.length > 0 &&
                        selectedCategories.length === categories.length
                      }
                      indeterminate={
                        selectedCategories.length > 0 &&
                        selectedCategories.length < categories.length
                      }
                    />
                    <ListItemText
                      primary={
                        selectedCategories.length === categories.length
                          ? "Clear All"
                          : "Select All"
                      }
                    />
                  </MenuItem>

                  {categories?.map((cat) => (
                    <MenuItem
                      key={cat?.id}
                      value={cat?.id}
                      onClick={(e) =>
                        handleItemClick(
                          e,
                          cat?.id,
                          selectedCategories,
                          setSelectedCategories
                        )
                      }
                    >
                      <Checkbox
                        checked={selectedCategories.includes(cat?.id)}
                      />
                      <ListItemText primary={cat?.name} />
                    </MenuItem>
                  ))}
                </Select>
                {error && !selectedCategories?.length ? (
                  <h6 className="err_msg">Category is required</h6>
                ) : (
                  ""
                )}
              </div>

              {/* ---------- SUB-CATEGORY SELECT ---------- */}
              <div className="control_group w_33">
                <label htmlFor="subCategory">
                  Sub-Category{" "}
                  <Tooltip
                    title="Once submitted, your request will be reviewed by the admin team to ensure alignment with your registered trade license."
                    enterTouchDelay={0}
                    leaveTouchDelay={1000}
                  >
                    <span className="info_icon">
                      <InfoOutlinedIcon fontSize="small" />
                    </span>
                  </Tooltip>
                </label>

                <Select
                  multiple
                  displayEmpty
                  open={openSubCategory}
                  disabled={!selectedCategories?.length}
                  onOpen={() => setOpenSubCategory(true)}
                  onClose={() => setOpenSubCategory(false)}
                  value={selectedSubCategories}
                  renderValue={(selected) => {
                    if ((selected as string[]).length === 0) {
                      return (
                        <span style={{ color: "#999" }}>
                          Select Sub-Category
                        </span>
                      );
                    }
                    return (selected as string[])
                      .map(
                        (id) =>
                          subCategories?.find((cat) => cat.id === id)?.name
                      )
                      .filter(Boolean)
                      .join(", ");
                  }}
                  fullWidth
                  MenuProps={{
                    PaperProps: { style: { maxHeight: 300 } },
                  }}
                >
                  {/* Select All / Clear All */}
                  <MenuItem
                    value="all"
                    onClick={(e) =>
                      handleSelectAll(
                        e,
                        subCategories?.map((cat) => cat?.id),
                        selectedSubCategories,
                        setSelectedSubCategories
                      )
                    }
                  >
                    <Checkbox
                      checked={
                        subCategories.length > 0 &&
                        selectedSubCategories.length === subCategories.length
                      }
                      indeterminate={
                        selectedSubCategories.length > 0 &&
                        selectedSubCategories.length < subCategories.length
                      }
                    />
                    <ListItemText
                      primary={
                        selectedSubCategories.length === subCategories.length
                          ? "Clear All"
                          : "Select All"
                      }
                    />
                  </MenuItem>

                  {subCategories?.map((sub) => (
                    <MenuItem
                      key={sub?.name}
                      value={sub?.id}
                      onClick={(e) =>
                        handleItemClick(
                          e,
                          sub?.id,
                          selectedSubCategories,
                          setSelectedSubCategories
                        )
                      }
                    >
                      <Checkbox
                        checked={selectedSubCategories.includes(sub?.id)}
                      />
                      <ListItemText primary={sub?.name} />
                    </MenuItem>
                  ))}
                </Select>
                {error && !selectedSubCategories?.length ? (
                  <h6 className="err_msg">Sub-Category is required</h6>
                ) : (
                  ""
                )}
              </div>

              <div className="control_group w_100 ai_rec_btn">
                <label htmlFor="storeBio">
                  Store Bio
                  <p style={{ margin: 0 }}>(250 characters maximum)</p>
                </label>
                <Select fullWidth value={"default"} className="select_abs">
                  <MenuItem disabled value="default">
                    Select Template
                  </MenuItem>
                  {bioTemplates.map((template, index) => (
                    <MenuItem value="All">{template}</MenuItem>
                  ))}
                </Select>

                <TextField
                  id="bio"
                  name="bio"
                  placeholder="Enter Store Bio"
                  multiline
                  fullWidth
                  inputProps={{ maxLength: 250 }}
                  className="text_field"
                  value={formik.values.bio}
                  onChange={(val) => {
                    if (val.target.value === " " || val.target.value === ".") {
                    } else {
                      formik.handleChange(val);
                    }
                  }}
                  onBlur={formik.handleBlur}
                  helperText={
                    formik.touched.bio && typeof formik.errors.bio === "string"
                      ? formik.errors.bio
                      : ""
                  }
                />

                {/* AI Generation Button */}
                <Button className="btn btn_primary sm" type="button">
                  <img src="/static/images/ai_icon.svg" alt="" />
                  Generate My Bio with AI
                </Button>
              </div>

              <div className="form_btn">
                {/* <Button className="btn btn_primary" variant="contained" onClick={() => setOpenModal(true)}>
                  Edit
                </Button> */}
                <Button
                  className="btn btn_primary"
                  variant="contained"
                  type="submit"
                  onClick={() => setError(true)}
                >
                  Confirm
                </Button>
              </div>
            </div>
          </form>
        </div>
      </AuthLayout>
      <ChangeRequest
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default SignupForm;
